import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { IAnalyzerMission } from 'src/app/storage/interfaces/analyzer-mission.interface';
import { IAnalyzer } from 'src/app/storage/interfaces/analyzer.interface';
import { AnalyzerMission } from 'src/app/storage/models/analyzer-mission.model';
import { Analyzer } from 'src/app/storage/models/analyzer.model';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class AnalyzersService {

  missionAnalyzers$: BehaviorSubject<AnalyzerMission[]> = new BehaviorSubject(null);
  analyzers$: BehaviorSubject<Analyzer[]> = new BehaviorSubject(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  async getAnalyzers(marketname: string, missionId: string): Promise<Analyzer[] | null> {
    const translations = await this.translateService.get('ANALYZERS').toPromise();

    const response = await this.apiService.get(
      `${URL}analyzers/market/${marketname}/${missionId}`,
      translations['LABEL'],
      { showLoader: true }
    );

    return response ?
          response.analyzers.map((analyzer: IAnalyzer) => new Analyzer(analyzer)) :
          null;
  }

  async getMissionAnalyzers(missionId: string): Promise<AnalyzerMission[] | null> {
    const translations = await this.translateService.get('ANALYZERS').toPromise();

    const response = await this.apiService.get(
      `${URL}analyzers/mission/${missionId}`,
      translations['LABEL']
    );

    return response ?
          response.analyzers.map((missionAnalyzer: IAnalyzerMission) => new AnalyzerMission(missionAnalyzer)) :
          null;
  }

  async addUpdateMissionAnalyzer(missionId: string, missionAnalyzer: AnalyzerMission): Promise<boolean> {
    const translations = await this.translateService.get('ANALYZERS').toPromise();

    const payload = {
      analyzerpk: missionAnalyzer.analyzerpk,
      gatewayId: missionAnalyzer.gatewayId != null ? missionAnalyzer.gatewayId : missionAnalyzer.analyzer.gatewayId,
      fieldprotocolName: missionAnalyzer.fieldprotocolName,
      ...(missionAnalyzer.handleFlyingH2 ? { handleFlyingH2: true } : {})
    };

    const response = await this.apiService.post(
      `${URL}analyzers/mission/${missionId}`,
      payload,
      translations['LABEL'],
      { showLoader: true }
    );

    return response != null;
  }

  async removeMissionAnalyzer(missionId: string, analyzerId: string): Promise<boolean> {
    const translations = await this.translateService.get('ANALYZERS').toPromise();

    const response = await this.apiService.delete(
      `${URL}analyzers/mission/${missionId}/${analyzerId}`,
      translations['LABEL'],
      { showLoader: true }
    );

    return response != null;
  }
}
